export default "__VITE_ASSET__9c4b41f1__"